<template>

    <planning
        :planning-uri="route('api.v1.planning.show', {project_uuid: project.uuid})"
        :teams-info-uri="route('api.v1.planning.teams-info', {project_uuid: project.uuid})"
        :project="project.uuid"
        :show-budget="getProject.access.finance"
        :show-buttons="getProject.access.planning.edit"
    ></planning>

</template>

<script>

import { mapGetters } from 'vuex';
import Lang from '../../../Lang';
import Planning from "../../../components/Projects/Planning";

export default {

    components: {
        Planning
    },

    computed: {
        ...mapGetters([
            'getProject',
        ]),

        project() {
            return this.getProject;
        },
    },

    data() {
        return {
            Lang:Lang,
        }
    },

    metaInfo: {
        title:'Project planning',
    },

    name:'ProjectsDetailsPlanning',

}

</script>
